const DEFAULT_TEXT = 'Skąpiec.pl - porównywarka cen i ofert';

export function getLogoTitle(pageUrl?: string): string {
    return pageUrl === '/' ? DEFAULT_TEXT : 'Przejdź na stronę główną Skąpiec.pl';
}

export function getLogoAlt(pageUrl?: string): string {
    return pageUrl === '/' ? DEFAULT_TEXT : 'skapiec';
}
